export default {
  id: 57,
  title: 'Target #57 - Pillars',
  url: 'https://cssbattle.dev/play/57',
  colors: ['#191919', '#4F77FF', '#F9E492'],
  solution:
    '<a a><a b><style>body{background:#191919}a{position:fixed}a[a]{top:95;left:145;width:110;height:110;background:#4F77FF}a[b]{top:75;left:125;width:30;height:30;background:#4F77FF;border-radius:50%;box-shadow:120px 0 #4F77FF,120px 120px #4F77FF,0 120px #4F77FF,7.5px 7.5px 0 7.5px #F9E492,112.5px 7.5px 0 7.5px #F9E492,112.5px 112.5px 0 7.5px #F9E492,7.5px 112.5px 0 7.5px #F9E492,15px 15px 0 15px #191919,105px 15px 0 15px #191919,105px 105px 0 15px #191919,15px 105px 0 15px #191919}</style>',
}
